import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/http'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/tokens.css'
import './styles/breakpoints.css'
import './styles/shell.css'
import './styles/primitives.css'
import './styles/base.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ko from 'element-plus/dist/locale/ko.mjs'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'

// Day.js 플러그인 및 로케일 설정
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.locale('ko')

/*
 * 서버 세션이 끊긴 채(30일 만료 · 비활성화 · 서버 쪽 세션 삭제) localStorage 에 사용자만 남아 있으면
 * 라우터 가드는 통과시키고 화면마다 401 만 쌓인다 — 빈 목록과 실패 토스트가 뜨고 아무 데도 안 간다.
 * 어느 요청이든 401 이 오면 한 번만 사용자를 비우고 로그인 화면으로 보낸다.
 * store.state.user 가 이미 비어 있으면 아무것도 하지 않는다 — 로그인 화면의 상태 확인(401)이 다시 자기를 부르지 않는다.
 */
http.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401 && store.state.user) {
    store.commit('SET_USER', null)
    router.replace('/login').catch(() => {})
  }
  return Promise.reject(error)
})

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: ko
})

app.mount('#app')